module.exports = __webpack_public_path__ + "static/media/forest-camp.6ea63ab9.jpg";